(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["andoro-category-sidebar"] && !Shopify.designMode) return;
  try {
    if (!window.__andoroCategorySidebarInit) {
    window.__andoroCategorySidebarInit = true;
    const closeShell=(shell)=>{if(!shell)return;shell.classList.remove('is-open');const opener=shell.querySelector('[data-andoro-category-open]');const backdrop=shell.querySelector('[data-andoro-category-backdrop]');if(opener)opener.setAttribute('aria-expanded','false');if(backdrop)backdrop.hidden=true;document.documentElement.classList.remove('andoro-categories-open')};
    const initShell=(shell)=>{if(shell.dataset.andoroSidebarReady==='true')return;shell.dataset.andoroSidebarReady='true';const opener=shell.querySelector('[data-andoro-category-open]');const closer=shell.querySelector('[data-andoro-category-close]');const backdrop=shell.querySelector('[data-andoro-category-backdrop]');opener?.addEventListener('click',()=>{shell.classList.add('is-open');opener.setAttribute('aria-expanded','true');if(backdrop)backdrop.hidden=false;document.documentElement.classList.add('andoro-categories-open');closer?.focus()});closer?.addEventListener('click',()=>closeShell(shell));backdrop?.addEventListener('click',()=>closeShell(shell))};
    const initAll=()=>document.querySelectorAll('[data-andoro-category-shell]').forEach(initShell);if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll,{once:true})}else{initAll()}document.addEventListener('shopify:section:load',initAll);document.addEventListener('keydown',(event)=>{if(event.key==='Escape'){document.querySelectorAll('[data-andoro-category-shell].is-open').forEach(closeShell)}})
  }
  } catch(e) { console.error(e); }
})();

})();
